import { useState, useEffect } from 'react';

export const useMarkdownContent = (billId: string | null) => {
  const [content, setContent] = useState<string>('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!billId) {
      setContent('');
      setLoading(false);
      setError(null);
      return;
    }

    const loadMarkdown = async () => {
      setLoading(true);
      setError(null);
      
      try {
        const response = await fetch(`/legislation/bills/${billId}.md`);
        if (!response.ok) {
          throw new Error('Failed to fetch markdown file');
        }
        const text = await response.text();
        setContent(text);
      } catch (err) {
        console.error('Error loading markdown:', err);
        setError('Failed to load bill content');
      } finally {
        setLoading(false);
      }
    };

    loadMarkdown();
  }, [billId]);

  return { content, loading, error };
};
